import { Transition } from '@uirouter/core';
import { Action } from '../../common/actions/core/action';
import { FamilyPlanTypes } from '../../common/services/package/package.model';

export class OpenStartListenAction implements Action {
  constructor(
   public type: FamilyPlanTypes
  ) {}
}



// WEBPACK FOOTER //
// src/app/family-plan/family-plan-member-start-listen-dialog/family-plan-member-start-listen-dialog.action.ts